import styled from '@emotion/styled';
import React from 'react';

import { H3 } from '../../../ComponentLibrary/text-elements/oc-h';

const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  min-height: 300px;
`;

const Spinner = styled.div`
  margin-bottom: 45px;
  position: relative;

  @keyframes spinner {
    0% {
      transform: translate3d(-50%, -50%, 0) rotate(0deg);
    }
    100% {
      transform: translate3d(-50%, -50%, 0) rotate(360deg);
    }
  }

  > div::before {
    animation: 1.5s linear infinite spinner;
    animation-play-state: inherit;
    border: solid 6px #e6e6e6;
    border-bottom-color: black;
    border-radius: 50%;
    content: '';
    height: 60px;
    width: 60px;
    position: absolute;
    transform: translate3d(-50%, -50%, 0);
    will-change: transform;
  }
`;

const LoadingEstimation = () => (
  <LoadingContainer>
    <Spinner>
      <div />
    </Spinner>
    <br />
    <H3>thanks for your patience</H3>
    <p>We're loading your estimate information.</p>
  </LoadingContainer>
);

export default LoadingEstimation;
